import React, { Component } from 'react';
import './App.css';
import Login from './login.js';
import TwoFactor from './twoFactor.js';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { FaBuilding, FaGlobe, FaUndo, FaIdBadge, FaSignOutAlt, FaTools, FaQuestion, FaEye, FaEyeSlash, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';


var Views = {}
var comps = require.context('./Views', false, /.*/)
comps.keys().forEach((item) => {
	Views[item.replace('./', '').split('.')[0]] = {}
	Views[item.replace('./', '').split('.')[0]].comp = comps(item)[item.replace('./', '').split('.')[0]]
	Views[item.replace('./', '').split('.')[0]].icon = comps(item).icon
})

var img = {}
var imgs = require.context('./img', false, /.*/)
imgs.keys().forEach((item) => {
	img[item.replace('./', '').split('.')[0]] = imgs(item)
})

class App extends Component {
	static propTypes = { cookies: instanceOf(Cookies).isRequired }
	constructor(props) {
		super(props);
		this.state = {
			domains: [],
			loggedIn: false,
			user: '',
			domain: '',
			org: '',
			progress: false,
			dynamicParams: {},
			RealTimeStats: {},
			firstName: '',
			lastName: '',
			adjustingPIN: false,
			adjustPIN: '',
			adjustPINError: '',
			showPassword: false,
			pinValidations: {
				length: false,
				upperLower: false,
				number: false,
				symbol: false
			},
			settingsOpen: false,
			settingsView: 'list', // 'list' | 'password' | 'email' | 'phone'
			adjustEmail: '',
			adjustEmailError: '',
			adjustPhone: '',
			adjustPhoneError: '',
			availableViews: [],
			views: [],
			memo: false,
			help: false,
			loginError: '',
			activeView: "RealTimeStats",
			dropdownDomainVisible: false,
			dropdownEmailVisible: false,
			idleTimeoutMs: 3600000,
			idleWarning: false,
			idleSecondsLeft: 60,
		};
		this.idleWarningLeadMs = 60000;
		this.idleCheckIntervalMs = 5000;
		this.lastUserActivity = Date.now();
		this.lastKeepAliveSentAt = 0;
	}

	handleUserActivity = () => {
		if (this.state.idleWarning) return;
		this.lastUserActivity = Date.now();
		if (!this.state.loggedIn) return;
		const idleTimeout = this.state.idleTimeoutMs || 3600000;
		const throttleMs = Math.min(60000, Math.max(15000, Math.floor(idleTimeout / 4)));
		const now = Date.now();
		if (this.ws && this.ws.readyState === 1 && now - this.lastKeepAliveSentAt > throttleMs) {
			this.ws.send(JSON.stringify({ route: 'keepAlive' }));
			this.lastKeepAliveSentAt = now;
		}
	}

	checkIdle = () => {
		if (!this.state.loggedIn) return;
		const idleTimeout = this.state.idleTimeoutMs || 3600000;
		const idleFor = Date.now() - this.lastUserActivity;
		if (idleFor >= idleTimeout) {
			this.setState({ idleWarning: false });
			this.logout();
			return;
		}
		if (idleFor >= idleTimeout - this.idleWarningLeadMs) {
			const secondsLeft = Math.max(0, Math.ceil((idleTimeout - idleFor) / 1000));
			if (!this.state.idleWarning) {
				this.setState({ idleWarning: true, idleSecondsLeft: secondsLeft });
			} else if (this.state.idleSecondsLeft !== secondsLeft) {
				this.setState({ idleSecondsLeft: secondsLeft });
			}
		}
	}

	stillThere = () => {
		this.lastUserActivity = Date.now();
		this.lastKeepAliveSentAt = Date.now();
		this.setState({ idleWarning: false, idleSecondsLeft: 60 });
		if (this.ws && this.ws.readyState === 1) {
			this.ws.send(JSON.stringify({ route: 'keepAlive' }));
		}
	}


	openSettings = (view = 'list') => {
		this.setState({
			settingsOpen: true,
			dropdownEmailVisible: true,
			settingsView: view,
			adjustPIN: '',
			adjustPINError: '',
			adjustEmail: this.state.user && this.state.user.email ? this.state.user.email : '',
			adjustEmailError: '',
			adjustPhone: this.state.user && this.state.user.phone ? this.state.user.phone : '',
			adjustPhoneError: ''
		});
	}
	adjustPINChange = (e) => {
		const val = e.target.value || '';
		const validations = {
			length: val.length >= 12,
			upperLower: /[A-Z]/.test(val) && /[a-z]/.test(val),
			number: /\d/.test(val),
			symbol: /[!@#$%\^&*()_+\-={}[\]|;:'",.<>/?`~]/.test(val)
		};
		this.setState({ adjustPIN: val, adjustPINError: '', pinValidations: validations });
	}
	adjustEmailChange = (e) => {
		this.setState({ adjustEmail: e.target.value, adjustEmailError: '' });
	}

	adjustPhoneChange = (e) => {
		const raw = e.target.value.replace(/\D/g, '');
		const digits = raw.startsWith('1') ? raw : '1' + raw;
		const formatted = this.formatPhoneNumber(digits);
		this.setState({ adjustPhone: digits, adjustPhoneError: '', formattedPhone: formatted });
	}

	formatPhoneNumber = (value) => {
		let cleaned = ('' + value).replace(/\D/g, '');
		if (cleaned.length <= 1) return '+1';
		let national = cleaned.slice(1);

		let formatted = '';
		if (national.length <= 3) {
			formatted = `(${national}`;
		} else if (national.length <= 6) {
			formatted = `(${national.slice(0, 3)}) ${national.slice(3)}`;
		} else {
			formatted = `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6, 10)}`;
		}

		return `+1 ${formatted}`;
	}
	help = (e) => {
		console.log('help')
		this.setState({ help: true })
	}

	confirmAdjustPIN = () => {
		const { adjustPIN, pinValidations } = this.state;
		const allValid = Object.values(pinValidations || {}).every(Boolean);
		if (!adjustPIN || !allValid) {
			this.setState({ adjustPINError: 'Please meet all password requirements before continuing.' });
			return;
		}
		this.setState({ loading: true, adjustPINError: '' });
		this.ws.send(JSON.stringify({ route: 'updateAccountSettings', password: adjustPIN }));
	}

	confirmAdjustEmail = () => {
		const email = (this.state.adjustEmail || '').trim();
		const isValid = /.+@.+\..+/.test(email);
		if (!isValid) {
			this.setState({ adjustEmailError: 'Please enter a valid email address' });
			return;
		}
		this.setState({ loading: true });
		this.ws.send(JSON.stringify({ route: 'updateAccountSettings', email }));
	}

	confirmAdjustPhone = () => {
		const phone = (this.state.adjustPhone || '').trim();
		const digitCount = (phone.match(/\d/g) || []).length;
		if (digitCount < 7) {
			this.setState({ adjustPhoneError: 'Please enter a valid phone number' });
			return;
		}
		this.setState({ loading: true });
		this.ws.send(JSON.stringify({ route: 'updateAccountSettings', phoneNumber: phone }));
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			if (this.state.settingsOpen) {
				if (this.state.settingsView === 'password') this.confirmAdjustPIN();
				if (this.state.settingsView === 'email') this.confirmAdjustEmail();
				if (this.state.settingsView === 'phone') this.confirmAdjustPhone();
			} else {
				this.confirmAdjustPIN();
			}
		}
	}
	base64ToBlob = (base64Data, contentType) => {

		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	revertToDashboard(e) {
		window.location.hash = ''
		e.stopPropagation();
	}

	// Central cookie options. SameSite=Lax mitigates CSRF (the browser won't
	// attach these cookies to cross-site state-changing requests) while still
	// allowing them on top-level navigations — needed for the SSO redirect
	// returns from Azure/Microsoft. Secure is set only over HTTPS so local
	// http://localhost dev login still works. See T557 / CWE-352.
	cookieOpts(extra) {
		return Object.assign({
			path: '/',
			sameSite: 'lax',
			secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
		}, extra || {});
	}



	componentWillMount() {
		this.cookies = this.props.cookies;

		if (this.cookies.get('dme') == 'true' && window.location.pathname == '/loginwithmicrosoft') {
			this.cookies.remove('dme')
			console.log('hit 4')
			window.location.pathname = '/dme'
		} else {
			console.log('hit 1')
			if (window.location.pathname == '/dme') {
				console.log('hit 2')
				this.cookies.set('dme', true, this.cookieOpts())
			}
			console.log('hit 3')
			this.connectWebSocket()


			this.saveCreds = (loginCreds) => {
				//this.setState({ loginCreds: loginCreds })
				//this.cookies.set('loginCreds', loginCreds, this.cookieOpts())
			}
			// We'll wait for backend to confirm login state
			this.pingTimer = 30000
			this.ping = setTimeout(this.checkSocket, this.pingTimer)
		}
	}

	connectWebSocket = () => {
		if (this.ws) {
			this.ws.close()
			delete this.ws
		}
		var protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
		var port = window.location.hostname == 'localhost' ? ':8765' : window.location.port ? ':' + window.location.port : ''

		this.forceUpdate()

		this.ws = new WebSocket(protocol + '//' + window.location.hostname + port);

		this.ws.onclose = (ev) => {
			console.warn('WS closed', { code: ev.code, reason: ev.reason, wasClean: ev.wasClean });
		};
		this.ws.onerror = (err) => {
			console.error('WS error', err);
		};

		this.ws.onopen = () => {
			console.log("HERE 1")
			console.log(this.state)
			if (this.cookies.get('microsoftNonce')) {
				this.ws.send(JSON.stringify({ route: 'completeSSOLogin', nonce: this.cookies.get('microsoftNonce') }))
				window.history.replaceState({}, '', '/')
			} else if (this.cookies.get('azureNonce')) {
				this.ws.send(JSON.stringify({ route: 'completeSSOLogin', nonce: this.cookies.get('azureNonce') }))
				window.history.replaceState({}, '', '/')
			}
			else if (this.cookies.get('session')) {
				console.log("There is a session cookie. Passing that back in ")
				this.ws.send(JSON.stringify({ route: 'login', reconnect: true, session: this.cookies.get('session') }))
			}
		};

		this.ws.onmessage = (e) => {
			console.log("HERE 2")
			var data = JSON.parse(e.data);

			// --- Prioritize handling TwoFactor state before other state updates
			if (data.route === "setState") {
				console.log("Setting Session Cookie")
				console.log("Its 10:09 PM why isnt this working")
				console.log(data.state)
				this.cookies.set('session', data.state.session, this.cookieOpts())
				console.log("Two Factor Method: " + data.state.twoFactorMethod)
				if (data.state.TwoFactor) {
					console.log("Two Factor is enabled")
					this.setState({
						TwoFactor: true,
						loggedIn: false,
						session: data.state.session,
						twoFactorMethod: data.state.twoFactorMethod,
						user: data.state.user,
						loginError: '',
					});
					return;
				}

				if (data.state.hasOwnProperty('domain')) {
					window.domain = data.state.domain
				}
				if (data.state.loggedIn && this.cookies.get('impersonating') && this.state.domain != this.cookies.get('impersonating')) {
					const cached = this.cookies.get('impersonating')
					const valid = Array.isArray(data.state.domains) && data.state.domains.indexOf(cached) >= 0
					if (!valid) {
						console.warn('Clearing stale impersonating cookie:', cached)
						this.cookies.remove('impersonating', this.cookieOpts())
						console.log("Setting Application State 1 (stale impersonate cleared)")
						console.log(data.state)
						this.setState(data.state)
					} else {
						data.state.domain = cached
						console.log('impersonating')
						console.log("Setting Application State 1")
						console.log(data.state)
						this.setState(data.state, () => {
							this.ws.send(JSON.stringify({ route: 'impersonate', domain: cached }))
						})
					}
				} else if (data.state.hasOwnProperty('RealTimeStats')) {
					if (this.state.activeView == 'Realtime%20Statistics') {
						console.log("Setting Application State 2")
						console.log(data.state)
						this.setState(data.state)
					}

				} else if (Object.keys(data.state).length == 1 && data.state.hasOwnProperty('NotificationDashboard')) {
					if (this.state.activeView == 'Notification%20Dashboard') {
						console.log("Setting Application State 3")
						console.log(data.state)
						this.setState(data.state)
					}

				} else {
					console.log("Setting Application State 4")
					console.log(data.state)
					this.setState(data.state)
					for (var stateType in data.state) {
						if (stateType === 'loggedIn') {
							this.cookies.set(stateType, data.state[stateType], this.cookieOpts())
						} else if (stateType === 'impersonating' && data.state[stateType]) {
							this.cookies.set(stateType, this.state.domain, this.cookieOpts())
						}
					}
				}
			} else if (data.route === "alterState") {
				console.log("Altering Application State")
				console.log(data.value)
				console.log(data)

				var altState = {}

				if (this.state[data.state]) {
					altState[data.state] = this.state[data.state]
				} else {
					altState[data.state] = {}
				}
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = altState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							path[data.path[i]] = data.value
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {

								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					altState[data.state][data.path] = data.value
				}

				this.setState(altState)
			} else if (data.route === "deleteState") {
				console.log("Deleting Application State")
				console.log(data.path)

				var delState = {}
				delState[data.state] = this.state[data.state]
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = delState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							delete path[data.path[i]]
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {
								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					delete delState[data.state][data.path]

				}



				this.setState(delState)
			} else if (data.route === "memo") {
				console.log("Alerting with memo")
				console.log(data.content)

				this.setState({ memo: data })
			} else if (data.route === "progress") {
				console.log("Updating Progress")
				console.log(data.content)

				this.setState({ progress: data })
			} else if (data.route === "loginWithMicrosoft") {
				console.log("Logging in with Microsoft")
				console.log(data.nonce)
				this.cookies.set('microsoftNonce', data.nonce, this.cookieOpts())
				window.location = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=0d803506-1f33-43b9-9149-ac49d3ace923&response_type=id_token&redirect_uri=" + window.location.origin + "/loginwithmicrosoft&response_mode=form_post&scope=openid&state=12345&nonce=" + data.nonce

			} else if (data.route === "publicAuthConfig") {
				console.log("Received Public Auth Config")
				this.setState({ publicAuthConfig: data.config });
			}
			else if (data.route === "loginWithAzureAD") {
				console.log("Logging in with AzureAD")
				console.log(data.nonce)
				this.cookies.set('azureNonce', data.nonce, this.cookieOpts())
				window.location = data.redirectURI
				//window.location = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=0d803506-1f33-43b9-9149-ac49d3ace923&response_type=id_token&redirect_uri=" + window.location.origin + "/loginwithAzureADt&response_mode=form_post&scope=openid&state=12345&nonce=" + data.nonce

			}
			else if (data.route === "download") {
				console.log("Updating Progress")
				console.log(data.file)

				if (window.navigator.msSaveOrOpenBlob) {
					console.log('This is IE!')
					var fileData = this.base64ToBlob(data.file, "application/zip");
					var blobObject = new Blob([fileData]);

					window.navigator.msSaveOrOpenBlob(blobObject, data.filename);

				} else {
					var url = window.URL.createObjectURL(this.base64ToBlob(data.file, "application/zip"));
					var a = document.createElement("a");
					a.style = "display: none";
					a.href = url;
					a.download = data.filename;

					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			} else if (data.route === "playAudio") {
				try {
					var audioUrl = 'data:audio/' + (data.format || 'mp3') + ';base64,' + data.audio;
					var audioEl = new Audio(audioUrl);
					audioEl.onplay = function() {
						if (window.AIChatbotsFunctions && window.AIChatbotsFunctions.onAudioStart) {
							window.AIChatbotsFunctions.onAudioStart();
						}
					};
					audioEl.onended = function() {
						if (window.AIChatbotsFunctions && window.AIChatbotsFunctions.onAudioEnd) {
							window.AIChatbotsFunctions.onAudioEnd();
						}
					};
					audioEl.play().catch(function(err) { console.log('Audio preview error:', err); });
				} catch(err) { console.log('Audio preview error:', err); }
			}
		};
	}

	checkSocket = () => {
		this.ping = setTimeout(this.checkSocket, this.pingTimer)

		if (this.ws.readyState !== 1) {
			this.forceUpdate();
			console.log(this.ws.readyState)
			this.pingTimer = Math.round(this.pingTimer * 1.25)
			this.connectWebSocket()
		} else {
			this.pingTimer = 1000
		}
	}

	logout = () => {
		this.cookies.remove('microsoftNonce', this.cookieOpts())
		this.cookies.remove('session', this.cookieOpts())
		this.cookies.remove('impersonating', this.cookieOpts())
		this.ws.send(JSON.stringify({ route: 'logOut' }))
	}

	cancel = () => {
		this.setState({
			memo: false,
			adjustingPIN: false,
			adjustPIN: '',
			adjustPINError: '',
			help: false,
			progress: false,
			settingsOpen: false,
			settingsView: 'list',
			adjustEmail: '',
			adjustEmailError: '',
			adjustPhone: '',
			adjustPhoneError: ''
		});
	}

	revert = (e) => {
		this.cookies.remove('impersonating', this.cookieOpts())
		this.ws.send(JSON.stringify({ route: 'revert' }))
	}
	impersonate = (e) => {
		console.log('impersonate')
		console.log(e)
		this.cookies.set('impersonating', e, this.cookieOpts())
		this.ws.send(JSON.stringify({ route: 'impersonate', domain: e }))
	}

	activateView = () => {
		if (window.location.hash.length > 3) {
			this.setState({ activeView: window.location.hash.replace('#', '') })
		} else if (this.state.views.length > 0) {
			window.location.hash = this.state.views[0].title
			this.activateView()
		}
	}

	componentDidMount() {
		window.addEventListener("hashchange", this.activateView, false);
		this.idleEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
		this.idleEvents.forEach(ev => window.addEventListener(ev, this.handleUserActivity, { passive: true }));
		this.idleInterval = setInterval(this.checkIdle, this.idleCheckIntervalMs);
	}

	componentWillUnmount() {
		window.removeEventListener("hashchange", this.activateView, false);
		if (this.idleEvents) this.idleEvents.forEach(ev => window.removeEventListener(ev, this.handleUserActivity));
		if (this.idleInterval) clearInterval(this.idleInterval);
	}


	componentDidUpdate() {
		if (window.location.hash.length < 3 && this.state.views.length > 0) {
			this.activateView()
		}
		if (this.state.loggedIn && !this.state.activeView) {
			this.activateView()
		}
	}
	activate = view => e => {
		window.location.hash = view;
		e.stopPropagation();
	}

	render() {
		var settingsModal = "";
		var helpMenu = ""
		if (this.state.help) {
			helpMenu = (
				<div className="blackout" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
					<div className="pop helpPage" style={{ padding: '30px', backgroundColor: '#fff', borderRadius: '8px', maxWidth: '450px', width: '100%', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center' }} onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ position: 'absolute', top: '10px', right: '10px', width: '24px', height: '24px', cursor: 'pointer' }} onClick={this.cancel}></div>

						<div className="helpContent">
							<h2 style={{ color: '#333', marginBottom: '20px', fontSize: '22px' }}>Contact Technical Support</h2>
							<p style={{ color: '#555', fontSize: '14px', marginBottom: '20px' }}>We’re here to help 24/7. Reach out through any of the following methods:</p>
							<div className="contactInfo" style={{ textAlign: 'left', fontSize: '14px', color: '#333' }}>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Phone:</strong> <span>(518) 438-6000, option 4</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Toll Free:</strong> <span>(800) 778-2927, option 4</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Emergency (After Hours):</strong> <span>(833) 890-0998, stay on the line for an engineer</span>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Email:</strong> <a href="mailto:techsupport@dirad.com" style={{ color: '#0073e6', textDecoration: 'none' }}>techsupport@dirad.com</a>
								</div>
								<div className="contactItem" style={{ marginBottom: '10px' }}>
									<strong>Helpdesk:</strong> <a href="https://support.dirad.com" target="_blank" rel="noopener noreferrer" style={{ color: '#0073e6', textDecoration: 'none' }}>support.dirad.com</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		var memo = ""
		if (this.state.memo) {
			memo = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>

						<div style={{ color: this.state.memo.color, marginBottom: '25px' }} >
							{this.state.memo.content}
						</div>

						{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.cancel}>Okay</div>}
					</div>
				</div>
			)
		}


		var progress = ""
		if (this.state.progress) {
			progress = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter} style={{ width: '300px' }}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
						<pre ><div style={{ fontFamily: 'Arial' }}>{this.state.progress.content}</div></pre>
						<div style={{ height: '20px', transition: 'width .5s', backgroundColor: this.state.progress.color, width: this.state.progress.perc + '%', margin: '25px 0px' }} ></div>
					</div>
				</div>
			)
		}
		// Build a centered modal only when editing a setting
		if (this.state.settingsOpen && this.state.settingsView !== 'list') {
			settingsModal = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={() => this.setState({ settingsView: 'list' })}></div>

						{this.state.settingsView === 'password' && (
							<>
								<div className="snazzyInputRow" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
									<div className="snazzyInputBox" style={{ flex: '1 1 auto' }}>
										<input
											className="textInput"
											type={this.state.showPassword ? 'text' : 'password'}
											required
											value={this.state.adjustPIN}
											onChange={this.adjustPINChange}
											aria-describedby="pw-reqs"
										/>
										<span className="inputBar"></span>
										<label className="textLabel">Choose Your New Password</label>
									</div>
									<button
										type="button"
										aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
										onClick={() => this.setState({ showPassword: !this.state.showPassword })}
										style={{
											background: 'transparent',
											border: '1px solid #ccd6dd',
											borderRadius: '8px',
											padding: '6px 10px',
											cursor: 'pointer',
											lineHeight: 0
										}}
									>
										{this.state.showPassword ? <FaEyeSlash /> : <FaEye />}
									</button>
								</div>
								<div className="error">{this.state.adjustPINError}</div>
								<div id="pw-reqs" className="passwordRequirements" style={{ marginTop: 0 }}>
									<ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
										<li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											{this.state.pinValidations.length ? <FaCheckCircle color="#2ecc71" /> : <FaTimesCircle color="#e74c3c" />}
											<span>At least 12 characters</span>
										</li>
										<li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											{this.state.pinValidations.upperLower ? <FaCheckCircle color="#2ecc71" /> : <FaTimesCircle color="#e74c3c" />}
											<span>One uppercase and one lowercase letter</span>
										</li>
										<li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											{this.state.pinValidations.number ? <FaCheckCircle color="#2ecc71" /> : <FaTimesCircle color="#e74c3c" />}
											<span>At least one number</span>
										</li>
										<li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
											{this.state.pinValidations.symbol ? <FaCheckCircle color="#2ecc71" /> : <FaTimesCircle color="#e74c3c" />}
											<span>At least one symbol (e.g., ! @ # $ %)</span>
										</li>
									</ul>
								</div>
								{this.state.loading ? (
									<div className="loader" style={{ marginTop: '12px' }}></div>
								) : (
									<button
										className="button"
										onClick={this.confirmAdjustPIN}
										disabled={!Object.values(this.state.pinValidations || {}).every(Boolean)}
										style={{
											marginTop: '12px',
											opacity: Object.values(this.state.pinValidations || {}).every(Boolean) ? 1 : 0.5,
											cursor: Object.values(this.state.pinValidations || {}).every(Boolean) ? 'pointer' : 'not-allowed'
										}}
									>
										Change My Password
									</button>
								)}
							</>
						)}

						{this.state.settingsView === 'email' && (
							<>
								<div className="snazzyInputBox">
									<input className="textInput" type="email" required value={this.state.adjustEmail} onChange={this.adjustEmailChange} style={{ minWidth: '300px' }} />
									<span className="inputBar"></span><label className="textLabel">Update Email Address</label>
								</div>
								<div className="error">{this.state.adjustEmailError}</div>
								{this.state.loading ? <div className="loader"></div> : (
									<div className="button" onClick={this.confirmAdjustEmail}>Update Email</div>
								)}
							</>
						)}

						{this.state.settingsView === 'phone' && (
							<>
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '8px', width: '100%' }}>
									<label htmlFor="phoneInput" style={{ fontWeight: '600', color: '#002948' }}>Update Phone Number</label>
									<div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
										<input
											id="phoneInput"
											type="tel"
											style={{
												padding: '10px 12px',
												border: '1px solid #ccc',
												borderRadius: '6px',
												fontSize: '14px',
												width: '100%',
												flex: 1
											}}
											required
											value={this.formatPhoneNumber(this.state.adjustPhone)}
											onChange={this.adjustPhoneChange}
										/>
									</div>
								</div>
								<div className="error">{this.state.adjustPhoneError}</div>
								{this.state.loading ? <div className="loader"></div> : (
									<div className="button" onClick={this.confirmAdjustPhone}>Update Phone</div>
								)}
							</>
						)}
					</div>
				</div>
			);
		}
		if (window.location.pathname == '/enroll') {
			//return (<Enrollment />);
		} else if (this.state.TwoFactor) {
			//loggedIn: false, loading: false, TwoFactor: true, user: user
			return (<TwoFactor ws={this.ws} loggedIn={this.state.loggedIn} twoFactorMethod={this.state.twoFactorMethod} session={this.state.session} loginError={this.state.loginError} />);
		} else if (!this.state.loggedIn) {
			return (<Login publicAuthConfig={this.state.publicAuthConfig} saveCreds={this.saveCreds} ws={this.ws} onLoginAttempt={this.loginAttempt} onLogin={this.successfulLogin} loggedIn={this.state.loggedIn} loginError={this.state.loginError} />);
		} else if (window.location.pathname == '/dme') {
			//return (<Dme />);
		} else {
			if (this.state.views && this.state.views.length > 0 && encodeURIComponent(this.state.activeView) !== encodeURIComponent(window.location.hash.replace('#', ''))) {
				console.log(this.state.activeView + decodeURIComponent(window.location.hash.replace('#', '')) + this.state.views[0].title)
				window.location.hash = encodeURIComponent(this.state.views[0].title)
			}

			for (var views = [], i = 0; i < this.state.views.length; i++) {
				for (var viewData = {}, a = 0; a < this.state.views[i].data.length; a++) {
					viewData[this.state.views[i].data[a]] = this.state[this.state.views[i].data[a]];
				}
				viewData[this.state.views[i].view] = this.state[this.state.views[i].view]
				console.log(this.state.views[i].view)
				console.log(i)
				console.log(this.state.views[i])
				var ViewType = Views[this.state.views[i].view].comp
				window[this.state.views[i].view + 'Functions'] = ViewType
				views.push(
					<div key={"view" + i} id={this.state.views[i].view} className={this.state.activeView === encodeURIComponent(this.state.views[i].title) ? 'active view' : 'view'} >
						{/* <div className="viewHeader">
							<h1>{this.state.views[i].title}</h1>
						</div> */}

						<ViewType img={img} view={this.state.views[i].view} ref={(component) => { if (component) { window[component.props.view + 'Functions'] = component } }} features={this.state.features} ws={this.ws} data={viewData} active={this.state.activeView === encodeURIComponent(this.state.views[i].title)} />
					</div>
				)
			}
			var navOptions = []
			for (var option of this.state.availableViews) {
				if (option.split) {
					navOptions.push(
						<div key={'splitter_' + option.title} style={{ margin: '16px 0 4px', padding: '0 16px' }}>
							{option.title && <div style={{ fontSize: '9px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)', marginBottom: '6px', textAlign: 'right' }}>{option.title}</div>}
							<div style={{ borderTop: '1px solid rgba(255,255,255,0.15)' }} />
						</div>
					)
					continue
				}
				navOptions.push(<div key={option.title} style={this.state.activeView && (this.state.activeView == encodeURIComponent(option.title) || this.state.activeView == option.title) ? { backgroundColor: '#2A6AA9' } : null} className="menuOption" onClick={this.activate(option.title)}><img src={img[Views[option.view].icon]} alt={option.title + " Icon"} /><div>{option.title}</div></div>)
			}
			return (
				<div style={{ display: "flex" }}>
					<nav
						className={this.state.menu ? "active" : ""}
						style={{ overflowY: "auto", overflowX: "hidden" }}
					>
						<div style={{ position: "absolute", width: "300px" }}>{navOptions}</div>
					</nav>

					<div className="App">
						<div className="floating-header">
							<div style={{ display: 'flex', alignItems: 'center', position: 'relative', zIndex: 50 }}>
								<div className="floating-header-item" onClick={this.revertToDashboard} style={{ position: 'relative', zIndex: 2, background: '#fff' }}>
									<img src={img.dirad_logo} alt="Dirad Logo" className="logo" />
								</div>
								{this.state.activeView && (
									<div style={{ background: '#002f5f', color: '#fff', padding: '12px 18px 12px 32px', borderRadius: '0 22px 22px 0', fontSize: '15px', fontWeight: 600, whiteSpace: 'nowrap', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginLeft: '-20px', position: 'relative', zIndex: 1 }}>
										{decodeURIComponent(this.state.activeView)}
									</div>
								)}
							</div>


							<div className="floating-nav" style={{ position: 'relative', zIndex: 1500 }}>
								<div
									className={`floating-nav-item ${this.state.dropdownDomainVisible ? "active" : ""
										}`}

									onClick={() =>
										(this.state.domains.length > 0) ? this.setState({
											dropdownDomainVisible: !this.state.dropdownDomainVisible,
											dropdownEmailVisible: false, // Close the other dropdown
										})
											: ""
									}
									style={{ position: "relative", zIndex: 50, minWidth: "180px" }}
									ref={(node) => (this.domainRef = node)}
								>
									<FaBuilding size={15} color="#ecf0f1" />
									<span>{this.state.org}</span>

									<div
										className={`dropdown ${this.state.dropdownDomainVisible ? "visible" : ""
											}`}
										style={{ zIndex: 51 }}
									>
										<div className="submenu-item" onClick={this.revert}>
											<FaUndo className="submenu-icon" />
											<span className="dropdown-button">Revert</span>
										</div>
										{this.state.domains.map((domain, index) => (
											<div
												key={index}
												className="submenu-item"
												onClick={() => this.impersonate(domain)}
											>
												<FaGlobe className="submenu-icon" />
												<span className="dropdown-button">{domain}</span>
											</div>
										))}
									</div>
								</div>

								<div
									className={`floating-nav-item ${this.state.dropdownEmailVisible ? "active" : ""
										}`}
									onClick={(e) => {
										e.stopPropagation();
										this.setState({
											dropdownEmailVisible: !this.state.dropdownEmailVisible,
											dropdownDomainVisible: false,
										});
									}}
									style={{ position: "relative", zIndex: 50, minWidth: "180px" }}
									ref={(node) => (this.emailRef = node)}
								>
									<FaIdBadge size={15} color="#ecf0f1" />
									<span>{this.state.user.email}</span>

									<div
										className={`dropdown ${this.state.dropdownEmailVisible ? "visible" : ""}`}
										style={{ zIndex: 51 }}
										onClick={(e) => e.stopPropagation()}
									>
										{this.state.settingsOpen ? (
											<div className="settingsDropdown" onKeyUp={this.checkEnter}>
												<div className="submenu-item" onClick={(e) => { e.stopPropagation(); this.setState({ settingsOpen: false, settingsView: 'list' }); }}>
													<span className="dropdown-button">← Back</span>
												</div>

												{
													<>
														<div className="settingsList" role="list" style={{ width: '240px' }}>
															<div className="settingsRow" role="listitem" onClick={(e) => { e.stopPropagation(); this.setState({ settingsView: 'password', adjustPIN: '', adjustPINError: '' }); }}>
																<div className="settingsCell">
																	<span className="settingsLabel">Password</span>
																	<span className="settingsValue">••••••••</span>
																</div>
																<button
																	className="settingsEditBtn"
																	onClick={(e) => { e.stopPropagation(); this.setState({ settingsView: 'password', adjustPIN: '', adjustPINError: '' }) }}
																>
																	Edit
																</button>
															</div>

															<div className="settingsRow" role="listitem" onClick={(e) => {
																e.stopPropagation(); this.setState({
																	settingsView: 'email',
																	adjustEmail: (this.state.user && this.state.user.email) ? this.state.user.email : (this.state.adjustEmail || ''),
																	adjustEmailError: ''
																});
															}}>
																<div className="settingsCell">
																	<span className="settingsLabel">Email</span>
																	<span className="settingsValue">
																		{(this.state.user && this.state.user.email) ? this.state.user.email : (this.state.adjustEmail || 'Not set')}
																	</span>
																</div>
																<button
																	className="settingsEditBtn"
																	onClick={(e) => {
																		e.stopPropagation(); this.setState({
																			settingsView: 'email',
																			adjustEmail: (this.state.user && this.state.user.email) ? this.state.user.email : (this.state.adjustEmail || ''),
																			adjustEmailError: ''
																		})
																	}}
																>
																	Edit
																</button>
															</div>

															<div className="settingsRow" role="listitem" onClick={(e) => {
																e.stopPropagation(); this.setState({
																	settingsView: 'phone',
																	adjustPhone: (this.state.user && this.state.user.phone) ? this.state.user.phone : (this.state.adjustPhone || ''),
																	adjustPhoneError: ''
																});
															}}>
																<div className="settingsCell">
																	<span className="settingsLabel">Phone</span>
																	<span className="settingsValue">
																		{this.formatPhoneNumber(this.state.user && this.state.user.phone ? this.state.user.phone : '') || 'Not set'}
																	</span>
																</div>
																<button
																	className="settingsEditBtn"
																	onClick={(e) => {
																		e.stopPropagation(); this.setState({
																			settingsView: 'phone',
																			adjustPhone: (this.state.user && this.state.user.phone) ? this.state.user.phone : (this.state.adjustPhone || ''),
																			adjustPhoneError: ''
																		})
																	}}
																>
																	Edit
																</button>
															</div>
														</div>
													</>
												}
											</div>
										) : (
											<>
												<div className="submenu-item" onClick={(e) => { e.stopPropagation(); this.openSettings('list'); }}>
													<FaTools className="submenu-icon" />
													<span className="dropdown-button">Settings</span>
												</div>
												<div className="submenu-item" onClick={(e) => { e.stopPropagation(); this.logout(); }}>
													<FaSignOutAlt className="submenu-icon" />
													<span className="dropdown-button">Logout</span>
												</div>
												<div className="submenu-item" onClick={(e) => { e.stopPropagation(); this.help(); }}>
													<FaQuestion className="submenu-icon" />
													<span className="dropdown-button">Help</span>
												</div>
											</>
										)}
									</div>
								</div>
							</div>



						</div>

						<div className="body">
							<div className="viewer activated">{views}</div>
						</div>

						{settingsModal}
						{helpMenu}
						{memo}
						{progress}
						{this.state.loggedIn && this.state.idleWarning && (
							<div className="blackout" tabIndex="1" autoFocus style={{ zIndex: 2000 }}>
								<div className="pop" style={{ display: 'flex', flexDirection: 'column', width: '420px', maxWidth: '94vw', padding: '0', position: 'relative', overflow: 'hidden' }}>
									<div style={{ background: '#002f5f', padding: '22px 28px 16px', color: '#fff' }}>
										<div style={{ fontSize: '11px', fontWeight: '700', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', marginBottom: '5px' }}>Session</div>
										<div style={{ fontSize: '21px', fontWeight: '700' }}>Are you still there?</div>
									</div>
									<div style={{ padding: '22px 28px', textAlign: 'center' }}>
										<p style={{ color: '#555', marginBottom: '20px' }}>
											You will be logged out in <strong>{this.state.idleSecondsLeft}</strong> second{this.state.idleSecondsLeft === 1 ? '' : 's'} due to inactivity.
										</p>
										<button className="button" onClick={this.stillThere} style={{ minWidth: '160px', borderRadius: 0, boxShadow: 'none', fontSize: '16px', padding: '12px 24px' }}>Yes, I'm here</button>
									</div>
								</div>
							</div>
						)}

						{/* Inline Styles */}
						<style jsx>{`
							  .floating-header {
							    display: flex;
							    align-items: center;
							    justify-content: space-between;
							    padding: 15px 30px;
							    background-color: transparent;
							    color: #002948;
							    /* No z-index here — splits the stacking context so the logo (left)
							       and the nav (right) can each set their own z-index independently:
							       logo sits below the view (1100) so dialogs grey it out; the nav
							       sits above (1500) so dropdowns remain interactive. */
							  }
													
							  .floating-header-item {
							    color: #002948;
							    padding: 10px 20px;
							    border-radius: 20px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    display: inline-block;
							    cursor: pointer;
							  }
													
							  .floating-header-item .logo {
							    height: 40px;
							    display: block;
							  }
													
							  .floating-nav {
							    display: flex;
							    gap: 20px;
							  }
													
							  .floating-nav-item {
							    background-color: #002948;
							    color: #ecf0f1;
							    padding: 10px 20px;
							    border-radius: 20px;
							    display: flex;
							    align-items: center;
							    gap: 10px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    cursor: pointer;
							    position: relative;
							    transition: transform 0.2s, background-color 0.2s;
							    min-width: 180px;
							  }
													
							  .floating-nav-item.active,
							  .floating-nav-item:hover {
							    background-color: #2a6aa9;
							    transform: translateY(-5px);
							  }
													
							  .floating-nav-item span {
							    margin: 0;
							  }
													
							  .dropdown {
							  .settingsDropdown {
							    width: 100%;
							    padding: 0;
							  }
							    position: absolute;
							    top: 50px;
							    left: 15px; /* Adjust to move the dropdown to the right */
							    display: block;
							    visibility: hidden;
							    width: 100%;
							    padding: 10px 0;
							    opacity: 0;
							    transform: translateY(-20px);
							    transition: opacity 0.3s ease, transform 0.3s ease;
							  }
													
							  .dropdown.visible {
							    visibility: visible;
							    opacity: 1;
							    transform: translateY(0);
							  }
													
							  .submenu-item {
							    background-color: #002948;
							    color: #ecf0f1;
							    padding: 6px 8px; /* Reduced padding to make it narrower */
							    border-radius: 15px;
							    margin-bottom: 8px;
							    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
							    cursor: pointer;
							    transition: transform 0.2s, background-color 0.2s;
							    display: flex;
							    align-items: center;
							    justify-content: flex-start;
							    gap: 8px;
								  width: 120px; /* Reduced width to make it smaller */
								}
								.settingsTitle {
								  margin-top: 0;
								  font-size: 20px;
								  color: #002948;
								}
								.settingsList {
								  display: flex;
								  flex-direction: column;
								  gap: 10px;
								}
								.settingsRow {
								  display: flex;
								  align-items: center;
								  justify-content: space-between;
								  column-gap: 16px;
								  background-color: #002948; /* match submenu-item */
								  color: #ecf0f1;
								  border: none;              /* match submenu-item */
								  border-radius: 15px;       /* match submenu-item */
								  padding: 6px 8px;          /* match submenu-item reduced padding */
								  box-shadow: none !important; /* keep no shadow as requested */
								  cursor: default;
								  transition: transform 0.2s, background-color 0.2s;
								}
								.settingsRow:hover {
								  background-color: #2a6aa9; /* match submenu-item hover */
								  transform: translateY(-5px);
								}
								.settingsCell {
								  display: flex;
								  align-items: baseline;
								  gap: 10px;
								  min-width: 0;
								  color: #ecf0f1;
								}
								.settingsLabel {
								  font-weight: 600;
								  color: #ecf0f1;   /* match submenu text color */
								  white-space: nowrap;
								}
								.settingsValue {
								  color: #ecf0f1;   /* keep text legible on dark bg */
								  opacity: 0.9;     /* subtle contrast vs. label */
								  overflow: hidden;
								  text-overflow: ellipsis;
								  white-space: nowrap;
								  max-width: 46vw;
								}
								.settingsEditBtn {
								  background: #ecf0f1;      /* inverse of row for contrast */
								  color: #002948;
								  border: none;
								  border-radius: 15px;      /* echo submenu-item radius */
								  padding: 6px 10px;        /* echo submenu-item sizing */
								  cursor: pointer;
								  font-weight: 600;
								  margin-left: 16px;
								  transition: transform 0.2s, filter 0.2s;
								}
								.settingsEditBtn:hover { filter: brightness(0.95); transform: translateY(-2px); }
								.linkish {
								  display: inline-block;
								  margin-left: 12px;
								  margin-top: 10px;
								  color: #2a6aa9;
								  cursor: pointer;
								  font-weight: 600;
								}
													
							  .submenu-item:hover {
							    background-color: #2a6aa9;
							    transform: translateY(-5px);
							  }
													
							  .submenu-icon {
							    width: 16px;
							    height: 16px;
							  }
													
							  .dropdown-button {
							    color: #ecf0f1;
							  }
							  /* Segmented control for Settings */
							  .seg {
							    display: inline-flex;
							    gap: 0;
							    border: 1px solid #002948;
							    border-radius: 12px;
							    overflow: hidden;
							    margin-bottom: 20px;
							  }
							  .seg .seg-item {
							    background: #ffffff;
							    color: #002948;
							    border: none;
							    padding: 8px 14px;
							    cursor: pointer;
							    font-weight: 600;
							    letter-spacing: 0.2px;
							  }
							  .seg .seg-item + .seg-item {
							    border-left: 1px solid #002948;
							  }
							  .seg .seg-item:hover {
							    background: #f2f6fa;
							  }
							  .seg .seg-item.active,
							  .seg .seg-item[aria-selected="true"] {
							    background: #002948;
							    color: #ecf0f1;
							  }
							  .passwordRequirements ul li { line-height: 1.6; }
							  .button[disabled] { pointer-events: none; }
							  .snazzyInputRow button[aria-label*="password"] { min-width: 40px; }
							`
						}</style>
					</div>
				</div>
			);

		}
	}
}
export default withCookies(App);


